import { SET_LANG_MAP } from '../types/types';

const setLangMap = payload => ({
    type: SET_LANG_MAP,
    payload
});

export default setLangMap;
